import UIComponent from "../../common/UIComponent";
import "./index.css";

export default class markPoints extends UIComponent {
    constructor(domNode, interfaces, markPoints, AiHightlights) {
        super();
        this.interfaces = interfaces;
        this.node = document.querySelector(domNode);
        this.markPoints = markPoints;
        this.markPointsConfig = this.interfaces.markPointsConfig;
        this.AiHightlights = AiHightlights;

        if(this.interfaces.markPointsConfig.showAiHightlight && this.AiHightlights.length > 0) {
            const delimiter = this.interfaces.markPointsConfig.customTitleSeparator;
            this.markPoints = [
                ...this.markPoints,
                ...this.AiHightlights.map(item => ({
                    // msg: item.subject,
                    msg: delimiter ? item.subject.split(delimiter)[0] : item.subject,
                    // picurl: item.image_url,
                    picurl: "",
                    timePoint: Math.round(item.start_time / 1000) // 毫秒转秒，并四舍五入
                }))
            ];
            this.markPoints.sort((a, b) => a.timePoint - b.timePoint);
        }

        this.interfaces.on(VhallPlayer.LOADED, () => {
            let length = this.interfaces.getDuration();
            let width = this.node.offsetWidth;
            let minPercent = width > 0 ? 80 / width : 0;
            minPercent = minPercent * 100; 
            let maxPercent = 100 - minPercent;
            // 转换为百分比            
            maxPercent = maxPercent;

            this.markPoints = this.markPoints.map((item) => {
                return {
                    style: {
                        top: 0,
                        left: `${(item.timePoint / length) * 100}`
                    },
                    ...item
                }
            });
            this.markPoints.length && this.init(minPercent, maxPercent)
        })
    }

    init (minPercent, maxPercent) {
      const url = this.interfaces.vhallplayer.getStore().getKV('url');
      const head = url.split('//')[0];
      const domain = url.split('//')[1].split('/')[0];
        this.markPoints.forEach((item, idx) => {
            // 打点圆点
            let markPoint = document.createElement('div');
            markPoint.style.cssText = `left: ${item.style.left}%;`;
            markPoint.setAttribute('class', 'v-p-markpoint');

            // 内容区域
            let markContainer = document.createElement('div');
            markContainer.setAttribute('class', 'v-p-markpoint__mark');
            markContainer.style.backgroundColor = this.markPointsConfig.backgroundColor;
            let markPercent = item.style.left;
            (markPercent < minPercent) && (markPercent = minPercent);
            (markPercent > maxPercent) && (markPercent = maxPercent);
            markContainer.style.left = `${markPercent}%`
            markContainer.style.display = 'none';
            // 内容文字
            const markMsg = document.createElement('div');
            markMsg.setAttribute('class', 'v-p-markpoint-msg');
            markMsg.style.fontSize =  this.markPointsConfig.fontSize;
            markMsg.style.fontFamily = this.markPointsConfig.fontFamily;
            markMsg.style.color = this.markPointsConfig.color;
            markMsg.innerText = item.msg;
            markContainer.appendChild(markMsg);
            // 内容图片
            if (item.picurl) {
              const markImg = document.createElement('img');
              markImg.setAttribute('src', `${head}//${domain}${item.picurl}`);
              markImg.setAttribute('alt', ' ');
              markContainer.appendChild(markImg);
            }

            this.node.appendChild(markPoint);
            this.node.appendChild(markContainer);

            // 以下，打点圆点事件
            markPoint.addEventListener('click', (e) => {
                this.interfaces.setCurrentTime(+item.timePoint)
                e.preventDefault()
                e.stopPropagation()
            }, false);
            markPoint.addEventListener('mouseover', (e) => {
                markContainer.style.display = 'block';
                e.stopPropagation()
            }, false)
            // 阻止事件冒泡，触发 滚动条的拖动事件
            markPoint.addEventListener('mousedown', (e) => {
                e.preventDefault()
                e.stopPropagation()
            }, false)
            // 阻止事件冒泡，触发 滚动条的拖动事件
            markPoint.addEventListener('touchstart', (e) => {
                this.interfaces.setCurrentTime(+item.timePoint)

                // 先隐藏所有其他内容
                document.querySelectorAll('.v-p-markpoint__mark').forEach(container => {
                    container.style.display = 'none';
                });
                markContainer.style.display = 'block'
                e.preventDefault();
                e.stopPropagation()

                // 添加全局触摸监听用于隐藏内容
                const hideHandler = (e) => {
                    if (!markContainer.contains(e.target) && !markPoint.contains(e.target)) {
                        markContainer.style.display = 'none';
                        document.removeEventListener('touchstart', hideHandler);
                    }
                };
                document.addEventListener('touchstart', hideHandler, { once: true });
            }, false)
            markPoint.addEventListener('mouseout', (e) => {
                markContainer.style.display = 'none'
                e.preventDefault()
                e.stopPropagation()
            }, false)

        });
        

    }

    createPointNode(txt, position) {
        //
    }
}